import React from "react";

import {
    Label,
    Input,
    RadioGroup,
    FlexWrapper,
    FileInput,
    FieldWrapper,
} from "./styles";

import { months } from "./form-data";

export default function BuildingInformation({
    errors,
    touched,
    values,
    setFieldValue,
}) {
    let yearCurrent = new Date().getFullYear() + 2;

    let years = [];
    let range = [...Array(yearCurrent - 1981).keys()];

    for (let i = range.length - 1; i > -1; i--) {
        years.push(range[i] + 1981);
    }
    return (
        <>
            <Label id="status" column>
                Please indicate the status of your building*
                <RadioGroup
                    role="group"
                    aria-labelledby="status"
                    name="status"
                    valid={touched.status && !errors.status}
                    error={touched.status && errors.status}
                >
                    <Label>
                        <Input
                            type="radio"
                            name="status"
                            value="Not yet purchased"
                        />
                        Not yet purchased
                    </Label>
                    <Label>
                        <Input
                            type="radio"
                            name="status"
                            value="Purchased, not yet installed"
                        />
                        Purchased, not yet installed
                    </Label>
                    <Label>
                        <Input
                            type="radio"
                            name="status"
                            value="Purchased and installed"
                        />
                        Purchased and installed
                    </Label>
                </RadioGroup>
            </Label>

            {values.status === "Purchased and installed" && (
                <Label id="isOriginalPurchaser">
                    Are you the original purchaser?
                    {errors.isOriginalPurchaser && `*`}
                    <RadioGroup
                        inline
                        role="group"
                        aria-labelledby="isOriginalPurchaser"
                        name="isOriginalPurchaser"
                        valid={
                            touched.isOriginalPurchaser &&
                            !errors.isOriginalPurchaser
                        }
                        error={
                            touched.isOriginalPurchaser &&
                            errors.isOriginalPurchaser
                        }
                    >
                        <Label>
                            Yes
                            <Input
                                type="radio"
                                name="isOriginalPurchaser"
                                value="Yes"
                            />
                        </Label>
                        <Label>
                            No
                            <Input
                                type="radio"
                                name="isOriginalPurchaser"
                                value="No"
                            />
                        </Label>
                    </RadioGroup>
                </Label>
            )}

            {values.status === "Purchased and installed" && (
                <FieldWrapper>
                    <Label
                        id="wantsKeys"
                        style={{
                            transform: "translateY(3px)",
                            display: "flex",
                        }}
                    >
                        <Input
                            type="checkbox"
                            name="wantsKeys"
                            style={{
                                transform: "scale(1.5) translateX(-3px)",
                            }}
                        />
                        I only want to purchase keys
                    </Label>
                </FieldWrapper>
            )}

            {!values.wantsKeys &&
                (values.status === "Purchased, not yet installed" ||
                    values.status === "Purchased and installed") && (
                    <Label htmlFor="installMonth">
                        Approximate installation date (if applicable) Month/Year
                        <FlexWrapper spaceBetween>
                            <Input
                                inputType="select"
                                name="installMonth"
                                width={25}
                                id="install-month"
                                valid={
                                    touched.installMonth && !errors.installMonth
                                }
                                error={
                                    touched.installMonth && errors.installMonth
                                }
                            >
                                <option value={""} />
                                {months.map((el, index) => {
                                    return (
                                        <option
                                            key={el.abbreviation}
                                            value={el.name}
                                        >
                                            {el.name}
                                        </option>
                                    );
                                })}
                            </Input>
                            <Input
                                width={25}
                                inputType="select"
                                name="installYear"
                                id="install-year"
                                valid={
                                    touched.installYear && !errors.installYear
                                }
                                error={
                                    touched.installYear && errors.installYear
                                }
                            >
                                <option value="" />
                                {years.map((el, index) => {
                                    return (
                                        <option key={el} value={el}>
                                            {el}
                                        </option>
                                    );
                                })}
                            </Input>
                        </FlexWrapper>
                    </Label>
                )}

            {values.status === "Purchased and installed" && (
                <Label htmlFor="serial">
                    Serial number, if available (i.e. GS-123456789):
                    <Input
                        type="text"
                        name="serial"
                        autoCorrect="off"
                        autoComplete="off"
                        valid={touched.serial && !errors.serial}
                        error={touched.serial && errors.serial}
                    />
                </Label>
            )}

            {!values.wantsKeys && (
                <Label htmlFor="details" column>
                    {values.status !== "Not yet purchased"
                        ? `What is the issue with your Tuff Shed building that you need
                addressed? Please include specific details about the issue so we
                can better process your request.*`
                        : `How can we help you?`}

                    <Input
                        inputType="textarea"
                        rows={8}
                        name="details"
                        autoCorrect="on"
                        autoComplete="off"
                        valid={touched.details && !errors.details}
                        error={touched.details && errors.details}
                    />
                </Label>
            )}

            {!values.wantsKeys && values.status === "Purchased and installed" && (
                <Label htmlFor="images" column>
                    Please upload any photos showing your building issues here{" "}
                    <FileInput
                        id="images"
                        name="images"
                        type="file"
                        multiple
                        onChange={(event) => {
                            setFieldValue("images", event.currentTarget.files);
                        }}
                    />
                </Label>
            )}

            {!values.wantsKeys &&
                values.status !== "Not yet purchased" &&
                values.status && (
                    <Label htmlFor="hasContactedFactory">
                        Have you already contacted the local factory about this
                        issue?{errors.hasContactedFactory && `*`}
                        <RadioGroup
                            inline
                            role="group"
                            aria-labelledby="hasContactedFactory"
                            name="hasContactedFactory"
                            valid={
                                touched.hasContactedFactory &&
                                !errors.hasContactedFactory
                            }
                            error={
                                touched.hasContactedFactory &&
                                errors.hasContactedFactory
                            }
                        >
                            <Label>
                                Yes
                                <Input
                                    type="radio"
                                    name="hasContactedFactory"
                                    value="Yes"
                                />
                            </Label>
                            <Label>
                                No
                                <Input
                                    type="radio"
                                    name="hasContactedFactory"
                                    value="No"
                                />
                            </Label>
                        </RadioGroup>
                    </Label>
                )}
        </>
    );
}
